// extracted by mini-css-extract-plugin
export default {"BranchInfoBarContainer":"BranchInfoBar-module__BranchInfoBarContainer__DGzPkuI","Box":"BranchInfoBar-module__Box__qi6PQGe"};